import React from 'react';

import * as S from './StarRatingStyles';

const StarRating = (props) => {
	const { defaultStarImg, activeStarImg, starValue, iconWidth, iconHeight, margin } = props;

	const renderDefaultIcon = () => {
		let temp = [];
		for (let i = 0; i < 5; i++) {
			temp.push(<img key={i} width={iconWidth} height={iconHeight} src={defaultStarImg} alt={i} />);
		}
		return temp;
	};
	const renderActiveIcon = () => {
		let temp = [];
		for (let i = 0; i < 5; i++) {
			temp.push(<img key={i} width={iconWidth} height={iconHeight} src={activeStarImg} alt={i} />);
		}
		return temp;
	};

	const calculatedWidth = iconWidth * starValue + (1 * starValue);

	return (
		<S.StRating margin={margin}>
			<S.StRatingRow
				style={{ width: calculatedWidth }}
				active>
				{renderActiveIcon()}
			</S.StRatingRow>
			<S.StRatingRow>
				{renderDefaultIcon()}
			</S.StRatingRow>
		</S.StRating>
	);
};

export default StarRating;
